<template>
    <DataLabel
        v-tooltip
        :item="messageItem"
        :icon-class="iconClass"
        :none="$t('common.nil')"
        :title="title">
        <CountBadge class="ml-2" :count="count" :title="$t('messages.unread')" />
        <AttachmentLabel v-if="attachmentItem" class="ml-2" :attachment="attachmentItem" />
    </DataLabel>
</template>

<script>
import AttachmentLabel from '@/js/components/attachment/AttachmentLabel';
import CountBadge from '@/js/components/common/badges/CountBadge';
import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'MessageLabel',

    components: {AttachmentLabel, CountBadge, DataLabel},

    props: {
        message: {type: [String, Object], default: null},
        count: {type: Number, default: null},
        isOpen: {type: Boolean},
        hasError: {type: Boolean},
    },

    computed: {
        messageItem() {
            if (!this.message) {
                return null;
            }

            return this.message.subject
                ? {name: this.message.subject}
                : this.message;
        },

        attachmentItem() {
            if (!this.message) {
                return null;
            }

            return this.message.attachments_count > 0
                ? {name: ''}
                : null;
        },

        title() {
            if (this.message && this.message.sent_as_email) {
                return this.$t('messages.sent_as_email');
            }

            return null;
        },

        iconClass() {
            if (this.hasError) {
                return 'fa fa-fw fa-envelope text-danger';
            }

            if (this.message && this.message.sent_as_email) {
                return 'fa fa-fw fa-at text-info';
            }

            if (this.message && this.isOpen) {
                return 'far fa-fw fa-envelope-open text-info';
            }

            return 'far fa-fw fa-envelope';
        },
    },
};
</script>
